
// App PRE
import './app2Pre.js';

// Vue guest components
import './app2GuestComponents.js';

// App POST
import './app2Post.js';

window.vueApp.mount('#app');
